type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const ListParcelStatus = Object.freeze({
  WAIT_PARCEL_DETAIL: 1 as const,
  WAIT_INVOICE: 2 as const,
  CREATE_INVOICE: 3 as const,
  CANCEL: 4 as const,
});

export type ListParcelStatus = EnumLiteralsOf<typeof ListParcelStatus>;
